"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _reactHookForm = require("react-hook-form");

var _campaignPurpose = require("../../constants/campaignPurpose.constants");

var _campaignPurpose2 = require("./campaignPurpose.schemas");

var CampaignPurpose = function CampaignPurpose(_ref) {
  var control = _ref.control,
      errors = _ref.errors;
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    control: control,
    name: _campaignPurpose2.CampaignPurposeFields.CampaignPurpose,
    render: function render(_ref2) {
      var _errors$CampaignPurpo;

      var _ref2$field = _ref2.field,
          name = _ref2$field.name,
          value = _ref2$field.value,
          onChange = _ref2$field.onChange,
          onBlur = _ref2$field.onBlur;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ui.SelectFilter, {
        name: name,
        label: "Campaign Purpose",
        value: value,
        dataTestId: "CampaignSettings.CampaignPurpose",
        selectProps: {
          onBlur
        },
        error: !!errors[_campaignPurpose2.CampaignPurposeFields.CampaignPurpose],
        helperText: (_errors$CampaignPurpo = errors[_campaignPurpose2.CampaignPurposeFields.CampaignPurpose]) === null || _errors$CampaignPurpo === void 0 ? void 0 : _errors$CampaignPurpo.message,
        onFilterChange: function onFilterChange(v) {
          return onChange(v[name]);
        },
        fullWidth: true,
        required: true,
        renderItems: function renderItems() {
          return _campaignPurpose.CAMPAIGN_PURPOSE_OPTIONS.map(function (purpose) {
            return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
              key: purpose,
              value: purpose
            }, purpose);
          });
        }
      }), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
        in: value === _campaignPurpose.CUSTOM_CAMPAIGN_PURPOSE,
        unmountOnExit: true,
        mountOnEnter: true
      }, /*#__PURE__*/_react.default.createElement(_material.Box, {
        mt: 5
      }, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
        control: control,
        name: _campaignPurpose2.CampaignPurposeFields.OwnPurpose,
        render: function render(_ref3) {
          var _errors$CampaignPurpo2;

          var field = _ref3.field;
          return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({}, field, {
            fullWidth: true,
            label: "Other Purpose",
            required: true,
            variant: "outlined",
            error: !!errors[_campaignPurpose2.CampaignPurposeFields.OwnPurpose],
            helperText: (_errors$CampaignPurpo2 = errors[_campaignPurpose2.CampaignPurposeFields.OwnPurpose]) === null || _errors$CampaignPurpo2 === void 0 ? void 0 : _errors$CampaignPurpo2.message,
            inputProps: {
              'data-testid': 'CampaignSettings.OwnPurpose'
            }
          }));
        }
      }))));
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 5
  }, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    control: control,
    name: _campaignPurpose2.CampaignPurposeFields.NumberOfRecipients,
    render: function render(_ref4) {
      var _errors$CampaignPurpo3;

      var _ref4$field = _ref4.field,
          name = _ref4$field.name,
          value = _ref4$field.value,
          onChange = _ref4$field.onChange,
          onBlur = _ref4$field.onBlur;
      return /*#__PURE__*/_react.default.createElement(_ui.SelectFilter, {
        fullWidth: true,
        name: name,
        label: "Number Of Recipients (Ballpark)",
        value: value,
        dataTestId: "CampaignSettings.NumberOfRecipients",
        required: true,
        selectProps: {
          onBlur
        },
        error: !!errors[_campaignPurpose2.CampaignPurposeFields.NumberOfRecipients],
        helperText: (_errors$CampaignPurpo3 = errors[_campaignPurpose2.CampaignPurposeFields.NumberOfRecipients]) === null || _errors$CampaignPurpo3 === void 0 ? void 0 : _errors$CampaignPurpo3.message,
        onFilterChange: function onFilterChange(v) {
          return onChange(v[name]);
        },
        renderItems: function renderItems() {
          return _campaignPurpose.NUMBER_OF_RECIPIENTS_OPTIONS.map(function (numberItem) {
            return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
              key: numberItem,
              value: numberItem
            }, numberItem);
          });
        }
      });
    }
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(CampaignPurpose);

exports.default = _default;